import { DialogContent, DialogTitle, styled, Typography } from "@mui/material";

export const StyledPdfDialog = {
    DialogContainer: styled(DialogContent)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingLeft: 40,
        paddingRight: 40,
        paddingBottom: 20,
        overflow: "auto",
    })),
    TitleContainer: styled(DialogTitle)(({ theme }) => ({
        backgroundColor: `${theme.palette.primary.main}`,
        borderBottom: "1px solid green",
        boxSizing: "border-box",
        textAlign: "center",
        color: "white",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "default",
    })),
    TitleStyle: styled("span")(({ theme }) => ({
        flexGrow: 1,
    })),
    ContenedorPrincipal: styled("div")(({ theme }) => ({
        width: "100%",
    })),
    Footer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.primary.main}`,
        borderTop: `1px solid ${theme.palette.primary.main}`,
        boxSizing: "border-box",
        textAlign: "center",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        padding: "5px 70px 5px 70px",
    })),
    PageContainer: styled("div")(({ theme }) => ({
        overflow: "hidden",
        padding: 10,
    })),
    PageText: styled(Typography)(({ theme }) => ({
        marginTop: 10,
        fontWeight: 500,
    })),
}

export const StyledPdfTooLargeMessage = {
    Container: styled("div")(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 40px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        border: '2px dashed #dee2e6',
        borderRadius: '12px',
        margin: '20px 0',
        minHeight: '400px'
    })),
    Title: styled(Typography)(({ theme }) => ({
        color: '#495057',
        marginBottom: '15px',
        fontSize: '24px',
        fontWeight: 600
    })),
    Description: styled(Typography)(({ theme }) => ({
        color: '#6c757d',
        marginBottom: '10px',
        fontSize: '16px',
        lineHeight: '1.5'
    })),
    Recommendation: styled(Typography)(({ theme }) => ({
        color: '#6c757d',
        marginBottom: '30px',
        fontSize: '14px'
    })),
    ButtonsContainer: styled("div")(({ theme }) => ({
        display: 'flex',
        gap: '15px',
        flexWrap: 'wrap',
        marginBottom: '30px'
    })),
    LimitsInfo: styled("div")(({ theme }) => ({
        padding: '15px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderRadius: '6px',
        fontSize: '14px',
        color: '#856404',
        maxWidth: '400px'
    }))
}